import styled, { RuleSet } from 'styled-components';
import { FlexColumn } from '../../../../../styled/common';
import { Typography } from '../../../../ui/Typography';

export const FilterSectionContainer = styled(FlexColumn)<{ styles?: RuleSet }>`
  padding: 15px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  width: 100%;
  gap: 15px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    gap: 30px;
  }

  ${({ styles }) => styles}
`;

export const ChildrenContainer = styled(FlexColumn)`
  gap: 15px;
  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    flex: 1;
    min-width: 0;
  }
`;

export const SectionTitle = styled(Typography)`
  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 160px;
  }
`;
